// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scrollable-area_5f9f323e {
  clear: both;
}
.scrollable-area_5f9f323e::before,
.scrollable-area_5f9f323e::after {
  content: " ";
  display: table;
}
.scrollable-area_5f9f323e::after {
  clear: both;
}
.scrollable-area_5f9f323e {
  display: flex;
  border-top: thin solid #dce1e5;
  border-bottom: none;
}
.scrollable-area__left_5f9f323e {
  position: relative;
  z-index: 30;
}
.scrollable-area__right_5f9f323e {
  border-left: none;
  position: relative;
  overflow: hidden;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scrollable-area": `scrollable-area_5f9f323e`,
	"scrollable-area__left": `scrollable-area__left_5f9f323e`,
	"scrollable-area__right": `scrollable-area__right_5f9f323e`
};
export default ___CSS_LOADER_EXPORT___;
